import Select from '@global/FormInput/Select'
import { arrangeBy } from '@lib/searchFields'
import * as S from './SearchResultsCount.styled'

const SearchResultCount = ({
  searchView,
  metaData,
  orderBy,
  onOrderChange,
  visibleItems,
  includeSurroundingSuburbs,
  onIncludeSurroundingSuburbs,
}) => {
  return metaData.total ? (
    <S.SearchResultCount>
      {searchView !== 'map' && <span>1-{visibleItems} of&nbsp;</span>}
      <span>{metaData.total} results</span>

      <S.SearchResultCountActions>
        <label
          htmlFor='include-surrounding-suburbs'
          className='bp-checkbox-label'
        >
          <input
            id='include-surrounding-suburbs'
            type='checkbox'
            defaultChecked={includeSurroundingSuburbs}
            onChange={(e) => onIncludeSurroundingSuburbs(e.target.checked)}
          />
          Include surrounding suburbs
        </label>
        <Select
          defaultValue={
            arrangeBy.options.find((it) => it.value === orderBy) ?? null
          }
          options={arrangeBy.options}
          onChange={(option) => onOrderChange(option.value)}
        />
      </S.SearchResultCountActions>
    </S.SearchResultCount>
  ) : null
}

export default SearchResultCount
